import AntIcon from "@/components/icons/AntIcon";
import { URLQuery } from "@/utils/queryUtils";
import { validationConstants, validations } from "@/utils/validationUtils";
import { Button, Col, Form, Input, Row } from "antd";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router";
import { rowGutter } from "../../../../common/constants";
import { SearchPageRequest } from "../../../../common/types";

const colSpan = 6;

interface Props {
  searchParams: SearchPageRequest;
}

export const LifeInsuranceTariffGroupFilterForm = ({ searchParams }: Props) => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const [form] = Form.useForm<SearchPageRequest>();

  useEffect(() => {
    form.setFieldsValue(searchParams);
  }, [searchParams, form]);

  const handleFilterSubmit = (filter: SearchPageRequest) => {
    navigate(
      {
        search: URLQuery.searchParamsToString({
          searchParams: { ...filter, pageIndex: undefined },
          append: true,
        }),
      },
      { replace: true },
    );
  };

  return (
    <Form form={form} onFinish={handleFilterSubmit} layout="vertical" name="lifeInsuranceTariffGroupSearchForm">
      <Row gutter={rowGutter} justify="center">
        <Col span={colSpan}>
          <Form.Item
            name="keyword"
            label={t("common.search")}
            rules={[
              validations.size(
                validationConstants.SEARCH_KEYWORD_MIN_LENGTH,
                validationConstants.SEARCH_KEYWORD_MAX_LENGTH,
              ),
            ]}
          >
            <Input allowClear placeholder={t("lifeInsuranceTariff.helpers.tariffGroupSearchHint")} />
          </Form.Item>
        </Col>

        <Col flex="110px" className="no-title-space">
          <Form.Item>
            <Button type="primary" htmlType="submit" icon={<AntIcon type="search" />}>
              {t("common.filter")}
            </Button>
          </Form.Item>
        </Col>
      </Row>
    </Form>
  );
};
